<app-side-menu>
  <div class="contract-form-container">
    <div class="header">
      <h2>
        <i class="fas fa-rotate"></i>
        Renovar / Migrar contrato #{{ contractId ? contractId.toString().padStart(4, '0') : '0000' }}
      </h2>
      <p>
        Escolha se esta operação é <strong>renovação</strong> ou <strong>migração</strong>; o sistema grava isso nas <strong>observações</strong> do contrato ao confirmar.
        Em seguida, ajuste os dados e finalize nos pagamentos se necessário.
      </p>
    </div>

    <app-loading [show]="isLoading" message="Carregando dados do contrato..."></app-loading>

    <div *ngIf="!isLoading" class="form-card">

      <!-- Step Indicator -->
      <div class="steps-indicator">
        <div class="step" [class.active]="currentStep === 1" [class.completed]="currentStep > 1">
          <div class="step-number">1</div>
          <div class="step-info">
            <div class="step-title">Dados</div>
            <div class="step-subtitle">Contrato e Motorista</div>
          </div>
        </div>
        <div class="step-divider"></div>
        <div class="step" [class.active]="currentStep === 2">
          <div class="step-number">2</div>
          <div class="step-info">
            <div class="step-title">Pagamentos</div>
            <div class="step-subtitle">Caução e 1ª parcela</div>
          </div>
        </div>
      </div>

      <form [formGroup]="contractForm" (ngSubmit)="onSubmit()">

        <!-- STEP 1: Dados do contrato -->
        <div class="form-grid" *ngIf="currentStep === 1">

          <!-- Tipo de operação (observações) -->
          <div class="form-section">
            <h3><i class="fas fa-code-branch"></i> Tipo de operação *</h3>
            <div class="form-row renewal-op-row">
              <div class="form-check renewal-op-card">
                <input
                  class="form-check-input"
                  type="radio"
                  id="renewalOpRenewal"
                  formControlName="renewalOperationType"
                  value="renewal">
                <label class="form-check-label" for="renewalOpRenewal">
                  <strong>Renovação</strong>
                  <span class="d-block small text-muted">Continuidade do contrato (registra que foi renovado).</span>
                </label>
              </div>
              <div class="form-check renewal-op-card">
                <input
                  class="form-check-input"
                  type="radio"
                  id="renewalOpMigration"
                  formControlName="renewalOperationType"
                  value="migration">
                <label class="form-check-label" for="renewalOpMigration">
                  <strong>Migração</strong>
                  <span class="d-block small text-muted">Mudança de plano/contexto (registra que foi migrado).</span>
                </label>
              </div>
            </div>
          </div>

          <!-- Seção: Dados Básicos -->
          <div class="form-section">
            <h3><i class="fas fa-info-circle"></i> Dados Básicos</h3>

            <div class="form-row">
              <div class="form-group">
                <label for="productId" class="form-label">Produto/Plano *</label>
                <select id="productId" formControlName="productId" class="form-select"
                        (change)="onProductChange($event)"
                        [class.is-invalid]="contractForm.get('productId')?.invalid && contractForm.get('productId')?.touched">
                  <option value="">Selecione um produto</option>
                  <option *ngFor="let product of products" [value]="product.id">
                    {{ product.name }} ({{ product.code }}) - {{ formatPrice(product.basePrice) }}
                  </option>
                </select>
                <div class="invalid-feedback" *ngIf="contractForm.get('productId')?.invalid && contractForm.get('productId')?.touched">
                  Produto é obrigatório.
                </div>
              </div>
            </div>
          </div>

          <!-- Seção: Período do Contrato -->
          <div class="form-section">
            <h3><i class="fas fa-calendar-alt"></i> Período do Contrato</h3>

            <div class="form-row">
              <div class="form-group">
                <label for="startDate" class="form-label">Data de Início *</label>
                <input type="date" id="startDate" formControlName="startDate" class="form-control" readonly
                       [class.is-invalid]="contractForm.get('startDate')?.invalid && contractForm.get('startDate')?.touched"
                       [title]="'Data de início sempre é a data atual (hoje)'">
                <small class="form-text text-muted">
                  <i class="fa-solid fa-info-circle"></i> Data de início sempre será a data atual
                </small>
              </div>

              <div class="form-group">
                <label for="endDate" class="form-label">Data de Término *</label>
                <input type="date" id="endDate" formControlName="endDate" class="form-control"
                       [class.is-invalid]="contractForm.get('endDate')?.invalid && contractForm.get('endDate')?.touched"
                       [title]="'Data calculada automaticamente baseada no produto selecionado'">
                <small class="form-text text-muted">
                  <i class="fa-solid fa-info-circle"></i> Calculada automaticamente baseada no produto
                </small>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="billingCycle" class="form-label">Ciclo de Cobrança *</label>
                <select id="billingCycle" formControlName="billingCycle" class="form-select"
                        [class.is-invalid]="contractForm.get('billingCycle')?.invalid && contractForm.get('billingCycle')?.touched">
                  <option value="Diário">Diário</option>
                  <option value="Semanal">Semanal</option>
                  <option value="Mensal">Mensal</option>
                  <option value="Trimestral">Trimestral</option>
                  <option value="Anual">Anual</option>
                </select>
              </div>
            </div>
          </div>

          <!-- Seção: Dados do Motorista -->
          <div class="form-section">
            <h3><i class="fas fa-user"></i> Dados do Motorista</h3>

            <div class="form-row">
              <div class="form-group">
                <label for="driverName" class="form-label">Nome Completo *</label>
                <input type="text" id="driverName" formControlName="driverName" class="form-control"
                       placeholder="Nome completo do motorista"
                       [class.is-invalid]="contractForm.get('driverName')?.invalid && contractForm.get('driverName')?.touched">
              </div>
              <div class="form-group">
                <label for="driverCpfCnpj" class="form-label">CPF/CNPJ *</label>
                <input type="text" id="driverCpfCnpj" formControlName="driverCpfCnpj" class="form-control"
                       placeholder="000.000.000-00"
                       [class.is-invalid]="contractForm.get('driverCpfCnpj')?.invalid && contractForm.get('driverCpfCnpj')?.touched">
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="driverCnhNumber" class="form-label">Número da CNH</label>
                <input type="text" id="driverCnhNumber" formControlName="driverCnhNumber" class="form-control"
                       placeholder="12345678901">
              </div>
              <div class="form-group">
                <label for="driverCnhExpiryDate" class="form-label">Validade da CNH</label>
                <input type="date" id="driverCnhExpiryDate" formControlName="driverCnhExpiryDate" class="form-control">
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="driverEmail" class="form-label">E-mail</label>
                <input type="email" id="driverEmail" formControlName="driverEmail" class="form-control"
                       placeholder="email@exemplo.com">
              </div>
              <div class="form-group">
                <label for="driverPhone" class="form-label">Telefone</label>
                <input type="text" id="driverPhone" formControlName="driverPhone" class="form-control"
                       placeholder="(11) 99999-9999">
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="driverStreet" class="form-label">Rua *</label>
                <input type="text" id="driverStreet" formControlName="driverStreet" class="form-control"
                       placeholder="Nome da rua"
                       [class.is-invalid]="contractForm.get('driverStreet')?.invalid && contractForm.get('driverStreet')?.touched">
              </div>
              <div class="form-group">
                <label for="driverNumber" class="form-label">Número *</label>
                <input type="text" id="driverNumber" formControlName="driverNumber" class="form-control"
                       placeholder="123"
                       [class.is-invalid]="contractForm.get('driverNumber')?.invalid && contractForm.get('driverNumber')?.touched">
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="driverComplement" class="form-label">Complemento</label>
                <input type="text" id="driverComplement" formControlName="driverComplement" class="form-control"
                       placeholder="Apto 45, Bloco A">
              </div>
              <div class="form-group">
                <label for="driverDistrict" class="form-label">Bairro *</label>
                <input type="text" id="driverDistrict" formControlName="driverDistrict" class="form-control"
                       placeholder="Nome do bairro"
                       [class.is-invalid]="contractForm.get('driverDistrict')?.invalid && contractForm.get('driverDistrict')?.touched">
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="driverCity" class="form-label">Cidade *</label>
                <input type="text" id="driverCity" formControlName="driverCity" class="form-control"
                       placeholder="Nome da cidade"
                       [class.is-invalid]="contractForm.get('driverCity')?.invalid && contractForm.get('driverCity')?.touched">
              </div>
              <div class="form-group">
                <label for="driverState" class="form-label">Estado *</label>
                <input type="text" id="driverState" formControlName="driverState" class="form-control"
                       placeholder="SP" maxlength="2"
                       [class.is-invalid]="contractForm.get('driverState')?.invalid && contractForm.get('driverState')?.touched">
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="driverZipCode" class="form-label">CEP *</label>
                <input type="text" id="driverZipCode" formControlName="driverZipCode" class="form-control"
                       placeholder="01234-567"
                       [class.is-invalid]="contractForm.get('driverZipCode')?.invalid && contractForm.get('driverZipCode')?.touched">
              </div>
            </div>
          </div>

          <!-- Seção: Dados do Veículo -->
          <div class="form-section">
            <h3><i class="fas fa-car"></i> Dados do Veículo e Inspeção</h3>

            <div class="form-row">
              <div class="form-group vehicle-plate-group">
                <label for="vehiclePlate" class="form-label">Placa * <small class="text-muted">(digite para buscar)</small></label>
                <div class="input-group">
                  <input type="text" id="vehiclePlate" formControlName="vehiclePlate" class="form-control" placeholder="ABC-1234"
                         [class.is-invalid]="contractForm.get('vehiclePlate')?.invalid && contractForm.get('vehiclePlate')?.touched">
                  <button type="button" class="btn btn-outline-primary" (click)="searchVehicleByPlate()"
                          title="Buscar veículo cadastrado">
                    <i class="fas fa-search"></i>
                  </button>
                </div>
                <small *ngIf="isSearchingVehicles" class="text-muted"><i class="fas fa-spinner fa-spin"></i> Buscando...</small>
                <ul *ngIf="vehicleSearchResults.length > 0" class="autocomplete-list">
                  <li *ngFor="let v of vehicleSearchResults"
                      class="autocomplete-item"
                      (click)="onSelectVehicle(v)">
                    <strong>{{ v.plateNumber }}</strong> — {{ v.brand }} {{ v.model }} {{ v.modelYear || '' }}
                  </li>
                </ul>
              </div>
              <div class="form-group">
                <label for="vehicleModel" class="form-label">Modelo *</label>
                <input type="text" id="vehicleModel" formControlName="vehicleModel" class="form-control" placeholder="Honda CB 600"
                       [class.is-invalid]="contractForm.get('vehicleModel')?.invalid && contractForm.get('vehicleModel')?.touched">
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="vehicleYear" class="form-label">Ano *</label>
                <input type="number" id="vehicleYear" formControlName="vehicleYear" class="form-control" placeholder="2020"
                       [class.is-invalid]="contractForm.get('vehicleYear')?.invalid && contractForm.get('vehicleYear')?.touched">
              </div>
              <div class="form-group">
                <label for="vehicleColor" class="form-label">Cor</label>
                <input type="text" id="vehicleColor" formControlName="vehicleColor" class="form-control" placeholder="Vermelho">
              </div>
              <div class="form-group">
                <label for="vehicleBrand" class="form-label">Marca</label>
                <input type="text" id="vehicleBrand" formControlName="vehicleBrand" class="form-control" placeholder="Honda">
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="vehicleRenavam" class="form-label">RENAVAM</label>
                <input type="text" id="vehicleRenavam" formControlName="vehicleRenavam" class="form-control" placeholder="12345678901">
              </div>
              <div class="form-group">
                <label for="vehicleChassis" class="form-label">Chassi</label>
                <input type="text" id="vehicleChassis" formControlName="vehicleChassis" class="form-control" placeholder="9BW1234567890123">
              </div>
              <div class="form-group">
                <label for="vehicleCurrentKm" class="form-label">KM Atual</label>
                <input type="text" id="vehicleCurrentKm" formControlName="vehicleCurrentKm" class="form-control" placeholder="Ex: 15.000">
              </div>
            </div>

            <div class="form-group">
              <label for="vehicleInspectionNotes" class="form-label">Observações da Inspeção</label>
              <textarea id="vehicleInspectionNotes" formControlName="vehicleInspectionNotes" class="form-control"
                        rows="4" placeholder="Descreva o estado atual do veículo, avarias, quilometragem, etc..."></textarea>
            </div>
          </div>

        </div>

        <!-- STEP 2: Pagamentos -->
        <div class="form-grid" *ngIf="currentStep === 2">
          <div class="form-section">
            <h3><i class="fas fa-dollar-sign"></i> Pagamentos (Renovação)</h3>

            <!-- Aviso de cancelamento de boletos pendentes -->
            <div class="alert alert-warning" *ngIf="isProductChanged && asaasCustomerId" style="margin-bottom: 16px;">
              <i class="fa-solid fa-triangle-exclamation"></i>
              <strong>Plano alterado.</strong> Ao confirmar a renovação, todos os boletos <strong>pendentes</strong> do contrato anterior serão cancelados automaticamente, exceto a <strong>caução</strong> e a <strong>1ª parcela</strong> ainda pendentes. Os novos boletos serão gerados a partir da data de renovação.
            </div>

            <!-- Resumo da diferença de caução -->
            <div class="deposit-summary">
              <div class="summary-row">
                <div class="summary-item">
                  <span class="summary-label">Caução Anterior (já pago)</span>
                  <span class="summary-value">{{ formatPrice(previousDepositAmount) }}</span>
                </div>
                <div class="summary-item">
                  <span class="summary-label">Caução do Novo Plano</span>
                  <span class="summary-value">{{ formatPrice(newDepositAmount) }}</span>
                </div>
                <div class="summary-item highlight" [class.zero]="depositDifference === 0">
                  <span class="summary-label">Diferença a Cobrar</span>
                  <span class="summary-value">{{ formatPrice(depositDifference) }}</span>
                </div>
              </div>
            </div>

            <!-- Valor 1ª Parcela -->
            <div class="form-row" style="margin-top: 16px;">
              <div class="form-group">
                <label class="form-label">Diferença da 1ª Parcela a Cobrar</label>
                <input type="text" class="form-control" [value]="formatPrice(firstInstallmentDifference)" readonly>
              </div>
            </div>

            <!-- Caução (apenas se houver diferença) -->
            <div *ngIf="depositDifference > 0">
              <hr>
              <h4 class="sub-section-title"><i class="fas fa-shield-alt"></i> Diferença de Caução - {{ formatPrice(depositDifference) }}</h4>

              <div class="form-row">
                <div class="form-group" style="width: 100%;">
                  <label class="form-label">Quantidade de métodos de pagamento</label>
                  <select class="form-select"
                          [(ngModel)]="depositPaymentMode"
                          (ngModelChange)="setDepositPaymentMode($event)"
                          [ngModelOptions]="{ standalone: true }">
                    <option [ngValue]="'single'">1 método</option>
                    <option [ngValue]="'split'">2 métodos</option>
                  </select>
                </div>
              </div>

              <div class="form-row" *ngFor="let p of depositPayments; let i = index"
                   [hidden]="depositPaymentMode === 'single' && i === 1">
                <div class="form-group">
                  <label class="form-label">Método {{ i + 1 }}</label>
                  <select class="form-select"
                          [ngModel]="depositPayments[i].method"
                          (ngModelChange)="onDepositMethodChange(i, $event)"
                          [ngModelOptions]="{ standalone: true }">
                    <option *ngFor="let m of paymentMethods" [value]="m.value">{{ m.label }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label class="form-label">Valor</label>
                  <input type="number" class="form-control currency-input"
                         [ngModel]="depositPayments[i].amount ? depositPayments[i].amount : null"
                         (ngModelChange)="onDepositAmountChange(i, $event)"
                         [ngModelOptions]="{ standalone: true }"
                         min="0" step="0.01"
                         [readonly]="depositPaymentMode === 'single'"
                         [max]="depositDifference">
                </div>
              </div>

              <!-- Parcelamento do boleto da caução -->
              <div class="form-row" *ngIf="hasDepositBoleto()">
                <div class="form-group">
                  <label class="form-label">Parcelas do boleto da caução</label>
                  <select class="form-select"
                          [(ngModel)]="depositInstallments"
                          [ngModelOptions]="{ standalone: true }">
                    <option [value]="1">À vista (1x)</option>
                    <option *ngFor="let n of [2,3,4,5,6,7,8,9,10]" [value]="n">{{ n }}x</option>
                  </select>
                  <small class="text-muted">
                    O valor em boleto será dividido em {{ depositInstallments }} parcela(s).
                  </small>
                </div>
              </div>

              <!-- Alert cartão sem Asaas -->
              <div class="form-row" *ngIf="hasDepositCard()">
                <div class="form-group" style="width: 100%;">
                  <div class="alert alert-info" *ngIf="!asaasCustomerId">
                    <i class="fa-solid fa-circle-info"></i>
                    Para pagar no cartão é necessário que o cliente esteja cadastrado no Asaas (CPF/CNPJ válido).
                  </div>
                </div>
              </div>

              <!-- Cartão 1 -->
              <div class="card-payment-wrapper" *ngIf="depositPayments[0]?.method === 'CREDIT_CARD'">
                <div class="card-visual">
                  <div class="card-visual-inner" [class.is-back]="isCardBack">
                    <div class="card-face card-front">
                      <div class="card-visual-header">
                        <span class="card-brand">
                          <i class="fa-solid fa-credit-card me-1"></i>
                          {{ cardBrand }}
                        </span>
                      </div>
                      <div class="card-visual-number">{{ maskedCardNumber }}</div>
                      <div class="card-visual-footer">
                        <div class="card-holder">
                          <span class="label">NOME</span>
                          <span class="value">{{ creditCardHolderName || 'NOME DO TITULAR' }}</span>
                        </div>
                        <div class="card-expiry">
                          <span class="label">VALIDADE</span>
                          <span class="value">{{ (creditCardExpiryMonth || 'MM') }}/{{ (creditCardExpiryYear || 'AAAA') }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="card-face card-back-face">
                      <div class="card-magnetic-strip"></div>
                      <div class="card-cvv-area">
                        <span class="label">CVV</span>
                        <span class="cvv-box">{{ creditCardCcv || '•••' }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-form">
                  <div class="form-row">
                    <div class="form-group">
                      <label class="form-label">Número do cartão</label>
                      <input type="text" class="form-control"
                             [(ngModel)]="creditCardNumber"
                             [ngModelOptions]="{ standalone: true }"
                             placeholder="0000 0000 0000 0000"
                             maxlength="19"
                             (input)="onCreditCardNumberInput($event)">
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group">
                      <label class="form-label">Nome impresso no cartão</label>
                      <input type="text" class="form-control"
                             [(ngModel)]="creditCardHolderName"
                             [ngModelOptions]="{ standalone: true }"
                             placeholder="Nome completo">
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group">
                      <label class="form-label">Validade (MM/AAAA)</label>
                      <div class="card-expiry-group">
                        <input type="text" class="form-control"
                               [(ngModel)]="creditCardExpiryMonth"
                               [ngModelOptions]="{ standalone: true }"
                               placeholder="MM" maxlength="2">
                        <span class="separator">/</span>
                        <input type="text" class="form-control"
                               [(ngModel)]="creditCardExpiryYear"
                               [ngModelOptions]="{ standalone: true }"
                               placeholder="AAAA" maxlength="4">
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="form-label">CVV</label>
                      <input type="text" class="form-control"
                             [(ngModel)]="creditCardCcv"
                             [ngModelOptions]="{ standalone: true }"
                             maxlength="4" placeholder="CVV"
                             (focus)="setCardBack(true, 1)"
                             (blur)="setCardBack(false, 1)">
                    </div>
                  </div>
                </div>
              </div>

              <!-- Cartão 2 -->
              <div class="card-payment-wrapper" *ngIf="depositPayments[1]?.method === 'CREDIT_CARD'">
                <div class="card-visual">
                  <div class="card-visual-inner" [class.is-back]="isCardBack2">
                    <div class="card-face card-front">
                      <div class="card-visual-header">
                        <span class="card-brand">
                          <i class="fa-solid fa-credit-card me-1"></i>
                          {{ cardBrand2 }}
                        </span>
                      </div>
                      <div class="card-visual-number">{{ maskedCardNumber2 }}</div>
                      <div class="card-visual-footer">
                        <div class="card-holder">
                          <span class="label">NOME</span>
                          <span class="value">{{ creditCardHolderName2 || 'NOME DO TITULAR' }}</span>
                        </div>
                        <div class="card-expiry">
                          <span class="label">VALIDADE</span>
                          <span class="value">{{ (creditCardExpiryMonth2 || 'MM') }}/{{ (creditCardExpiryYear2 || 'AAAA') }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="card-face card-back-face">
                      <div class="card-magnetic-strip"></div>
                      <div class="card-cvv-area">
                        <span class="label">CVV</span>
                        <span class="cvv-box">{{ creditCardCcv2 || '•••' }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-form">
                  <div class="form-row">
                    <div class="form-group">
                      <label class="form-label">Número do cartão (2)</label>
                      <input type="text" class="form-control"
                             [(ngModel)]="creditCardNumber2"
                             [ngModelOptions]="{ standalone: true }"
                             placeholder="0000 0000 0000 0000"
                             maxlength="19"
                             (input)="onCreditCardNumber2Input($event)">
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group">
                      <label class="form-label">Nome impresso no cartão (2)</label>
                      <input type="text" class="form-control"
                             [(ngModel)]="creditCardHolderName2"
                             [ngModelOptions]="{ standalone: true }"
                             placeholder="Nome completo">
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group">
                      <label class="form-label">Validade (MM/AAAA) (2)</label>
                      <div class="card-expiry-group">
                        <input type="text" class="form-control"
                               [(ngModel)]="creditCardExpiryMonth2"
                               [ngModelOptions]="{ standalone: true }"
                               placeholder="MM" maxlength="2">
                        <span class="separator">/</span>
                        <input type="text" class="form-control"
                               [(ngModel)]="creditCardExpiryYear2"
                               [ngModelOptions]="{ standalone: true }"
                               placeholder="AAAA" maxlength="4">
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="form-label">CVV (2)</label>
                      <input type="text" class="form-control"
                             [(ngModel)]="creditCardCcv2"
                             [ngModelOptions]="{ standalone: true }"
                             maxlength="4" placeholder="CVV"
                             (focus)="setCardBack(true, 2)"
                             (blur)="setCardBack(false, 2)">
                    </div>
                  </div>
                </div>
              </div>

              <!-- Parcelamento do cartão 1 -->
              <div class="form-row" *ngIf="depositPayments[0]?.method === 'CREDIT_CARD'">
                <div class="form-group">
                  <label class="form-label">Parcelas do cartão (Método 1)</label>
                  <select class="form-select"
                          [(ngModel)]="depositCardInstallments"
                          [ngModelOptions]="{ standalone: true }">
                    <option [value]="1">À vista (1x)</option>
                    <option *ngFor="let n of [2,3,4,5,6,7,8,9,10]" [value]="n">{{ n }}x</option>
                  </select>
                  <small class="text-muted">
                    O valor no cartão do Método 1 será dividido em {{ depositCardInstallments }} parcela(s).
                  </small>
                </div>
              </div>

              <!-- Parcelamento do cartão 2 -->
              <div class="form-row" *ngIf="depositPayments[1]?.method === 'CREDIT_CARD'">
                <div class="form-group">
                  <label class="form-label">Parcelas do cartão (Método 2)</label>
                  <select class="form-select"
                          [(ngModel)]="depositCardInstallments2"
                          [ngModelOptions]="{ standalone: true }">
                    <option [value]="1">À vista (1x)</option>
                    <option *ngFor="let n of [2,3,4,5,6,7,8,9,10]" [value]="n">{{ n }}x</option>
                  </select>
                  <small class="text-muted">
                    O valor no cartão do Método 2 será dividido em {{ depositCardInstallments2 }} parcela(s).
                  </small>
                </div>
              </div>
            </div>

            <!-- Mensagem quando caução está coberto -->
            <div *ngIf="depositDifference === 0 && newDepositAmount > 0" class="alert alert-success" style="margin-top: 16px;">
              <i class="fa-solid fa-check-circle"></i>
              O caução do plano anterior cobre o caução do novo plano. Não há diferença a cobrar.
            </div>

            <hr>

            <div *ngIf="firstInstallmentDifference === 0" class="alert alert-success" style="margin-bottom: 16px;">
              <i class="fa-solid fa-check-circle"></i>
              A 1ª parcela do plano anterior cobre a 1ª parcela do novo plano. Não há diferença a cobrar.
            </div>

            <div *ngIf="firstInstallmentDifference > 0">
              <h4 class="sub-section-title"><i class="fas fa-file-invoice-dollar"></i> 1ª Parcela (Diferença) - {{ formatPrice(firstInstallmentDifference) }}</h4>

              <div class="form-row">
                <div class="form-group" style="width: 100%;">
                  <label class="form-label">Quantidade de métodos de pagamento da 1ª parcela</label>
                  <select class="form-select"
                          [(ngModel)]="firstInstallmentPaymentMode"
                          (ngModelChange)="setFirstInstallmentPaymentMode($event)"
                          [ngModelOptions]="{ standalone: true }">
                    <option [ngValue]="'single'">1 método</option>
                    <option [ngValue]="'split'">2 métodos</option>
                  </select>
                </div>
              </div>

              <div class="form-row" *ngFor="let p of firstInstallmentPayments; let i = index"
                   [hidden]="firstInstallmentPaymentMode === 'single' && i === 1">
                <div class="form-group">
                  <label class="form-label">Método {{ i + 1 }}</label>
                  <select class="form-select"
                          [(ngModel)]="firstInstallmentPayments[i].method"
                          [ngModelOptions]="{ standalone: true }">
                    <option *ngFor="let m of paymentMethods" [value]="m.value">{{ m.label }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label class="form-label">Valor</label>
                  <input type="number" class="form-control currency-input"
                         [ngModel]="firstInstallmentPayments[i].amount ? firstInstallmentPayments[i].amount : null"
                         (ngModelChange)="onFirstInstallmentAmountChange(i, $event)"
                         [ngModelOptions]="{ standalone: true }"
                         min="0" step="0.01"
                         [readonly]="firstInstallmentPaymentMode === 'single'"
                         [max]="firstInstallmentDifference">
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Form Actions -->
        <div class="form-actions">
          <button type="button" class="btn-secondary" (click)="onCancel()" [disabled]="isLoading">
            <i class="fa-solid fa-times"></i>
            Cancelar
          </button>

          <button *ngIf="currentStep === 1"
                  type="button"
                  class="btn-primary"
                  (click)="goToStep(2)">
            Próximo
          </button>

          <ng-container *ngIf="currentStep === 2">
            <button type="button"
                    class="btn-secondary"
                    (click)="goToStep(1)">
              Voltar
            </button>
            <button type="submit"
                    class="btn-primary"
                    [disabled]="isSubmitDisabled">
              <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-2" role="status"></span>
              <i *ngIf="!isSaving" class="fa-solid fa-rotate me-2"></i>
              {{ submitButtonText }}
            </button>
          </ng-container>
        </div>
      </form>
    </div>
  </div>
</app-side-menu>
